import { FC, useEffect, useRef, useState } from 'react';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';

export const ItemTabs: FC<{ title?: string; list: string[]; onTabClick: (idx: number) => void }> = (props) => {
    const { gtm, useRouter } = useGlobal();
    const { locale } = useRouter();
    const container = useRef<HTMLDivElement>(null);
    const [activeIdx, setActiveIdx] = useState(0);
    const [lineWidth, setLineWidth] = useState(0);
    const [offset, setOffset] = useState(0);
    const [right, setRight] = useState(0);

    const handleClick = (idx: number, text: string) => {
        gtm.push({
            event: 'uaEvent',
            event_name: 'tab_click',
            button_name: text,
            list_name: props.title || 'none',
        });
        setActiveIdx(() => {
            const $items = container.current?.querySelectorAll<HTMLElement>('.item') ?? [];
            if (locale !== 'sa') {
                const offsetVal = $items[idx].offsetLeft - $items[0].offsetLeft;
                setOffset(offsetVal);
            } else {
                setRight(container.current?.offsetWidth - ($items[idx].offsetLeft + $items[idx].offsetWidth));
            }
            setLineWidth($items[idx].offsetWidth);
            return idx;
        });
        props.onTabClick(idx);
    };

    useEffect(() => {
        setLineWidth(container.current?.querySelector<HTMLElement>('.item')?.offsetWidth ?? 0);
    }, []);

    const itemList = props.list.map((text, idx) => (
        <div className={`item ${activeIdx === idx ? 'active' : ''}`} onClick={() => handleClick(idx, text)} key={text}>
            {text}
        </div>
    ));

    return (
        <div ref={container} className={`${css.ItemTabs}`}>
            {itemList}
            <div
                className="active-line"
                style={locale === 'sa' ? { width: lineWidth, right: `${right}px` } : { width: lineWidth, transform: `translateX(${offset}px)` }}
            ></div>
        </div>
    );
};
